import type { PropsWithChildren } from 'react'

import { cn } from '@mntn-dev/ui-utilities'

export const FormContainer = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div className={cn('flex h-full flex-col gap-6', className)}>{children}</div>
)
